import {IReportComparativeNomenclatureData, IReportComparativeStoresData, IReportDynamicsData, IReportTotalData} from "../../models/reports/performance.interface";
import {Action} from "@ngrx/store";


export enum EReportsPerformanceActions {
  GetTotal = '[Reports Performance] Get Total Report Data',
  GetTotalSuccess = '[Reports Performance] Get Total Report Data Success',
  GetTotalFailure = '[Reports Performance] Get Total Report Data Failure',

  GetComparativeStores = '[Reports Performance] Get ComparativeStores Report Data',
  GetComparativeStoresSuccess = '[Reports Performance] Get ComparativeStores Report Data Success',
  GetComparativeStoresFailure = '[Reports Performance] Get ComparativeStores Report Data Failure',

  GetComparativeNomenclature = '[Reports Performance] Get ComparativeNomenclature Report Data',
  GetComparativeNomenclatureSuccess = '[Reports Performance] Get ComparativeNomenclature Report Data Success',
  GetComparativeNomenclatureFailure = '[Reports Performance] Get ComparativeNomenclature Report Data Failure',

  GetDynamics = '[Reports Performance] Get Dynamics Report Data',
  GetDynamicsSuccess = '[Reports Performance] Get Dynamics Report Data Success',
  GetDynamicsFailure = '[Reports Performance] Get Dynamics Report Data Failure'
}

export class GetTotal implements Action {
  public readonly type = EReportsPerformanceActions.GetTotal;
}
export class GetTotalSuccess implements Action {
  public readonly type = EReportsPerformanceActions.GetTotalSuccess;
  constructor(public payload: Array<IReportTotalData>){}
}
export class GetTotalFailure implements Action {
  public readonly type = EReportsPerformanceActions.GetTotalFailure;
}
//----------------------------------------
export class GetComparativeStores implements Action {
  public readonly type = EReportsPerformanceActions.GetComparativeStores;
}
export class GetComparativeStoresSuccess implements Action {
  public readonly type = EReportsPerformanceActions.GetComparativeStoresSuccess;
  constructor(public payload: Array<IReportComparativeStoresData>){}
}
export class GetComparativeStoresFailure implements Action {
  public readonly type = EReportsPerformanceActions.GetComparativeStoresFailure;
}

//----------------------------------------
export class GetComparativeNomenclature implements Action {
  public readonly type = EReportsPerformanceActions.GetComparativeNomenclature;
}
export class GetComparativeNomenclatureSuccess implements Action {
  public readonly type = EReportsPerformanceActions.GetComparativeNomenclatureSuccess;
  constructor(public payload: Array<IReportComparativeNomenclatureData>){}
}
export class GetComparativeNomenclatureFailure implements Action {
  public readonly type = EReportsPerformanceActions.GetComparativeNomenclatureFailure;
}

//----------------------------------------
export class GetDynamics implements Action {
  public readonly type = EReportsPerformanceActions.GetDynamics;

}
export class GetDynamicsSuccess implements Action {
  public readonly type = EReportsPerformanceActions.GetDynamicsSuccess;
  constructor(public payload: Array<IReportDynamicsData>){}
}
export class GetDynamicsFailure implements Action {
  public readonly type = EReportsPerformanceActions.GetDynamicsFailure;
}

//-------------------

export type ReportsPerformanceActions =
  GetTotal |
  GetTotalSuccess |
  GetTotalFailure |

  GetComparativeStores |
  GetComparativeStoresSuccess |
  GetComparativeStoresFailure |

  GetComparativeNomenclature |
  GetComparativeNomenclatureSuccess |
  GetComparativeNomenclatureFailure |

  GetDynamics |
  GetDynamicsSuccess |
  GetDynamicsFailure;

